import { render, staticRenderFns } from "./ConsultoriaAnexos.vue?vue&type=template&id=47e38149"
import script from "./ConsultoriaAnexos.vue?vue&type=script&lang=js"
export * from "./ConsultoriaAnexos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports